'use client'

import React, {useEffect, useState} from 'react';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import PopNotification from './PopNotification';
import api from '@/util/api';
import { getCookie, setCookie } from '@/util/cookie';

export interface noticeListInterface {
    image: string
    pinned_order: number
    redirect_url: string
}

function CookieSetComponent() {
    const [noticeList, setNoticeList] = useState<noticeListInterface[]>([])

    useEffect(()=> {
        api(`/api/popup/`)
            .then(res => res.json())
            .then(({data}) => {
                // console.log(data)
                setNoticeList(data?.popup_list ?? [])
            })
    }, [])

    return (
        <>
            {/* <EventPopupDialog/> */}
            {
                noticeList.length ? <ComponentParent cookieNameList={noticeList}/> : <></>
            }
        </>
    )
}

export default CookieSetComponent;

function ComponentParent({cookieNameList}: {cookieNameList: noticeListInterface[]}){
    const [dialogAreaShow, setDialogAreaShow] = useState<boolean>(true)
    const [showLength, setShowLength] = useState<number>(0)

    function checkAdPopupCookiesCount(){
        let count: number = 0
        cookieNameList.forEach((value, key)=> {
            if(getCookie(`ad_${key}`) === undefined){
                setCookie(`ad_${key}`, `1`, {path: '/'})
            }

            if(getCookie(`ad_${key}`) == `1`){
                count++;
            }
        })
        setShowLength(count)
    }
    useEffect(()=> {
        if(showLength < 1) {
            setDialogAreaShow(false)
        }else{
            setDialogAreaShow(true)
        }
    }, [showLength])
    useEffect(()=> {
        checkAdPopupCookiesCount()
    }, [])
    return (
        <>
            {
                dialogAreaShow ?
                    <div className={"pn-dialog ad_0"} >
                        {
                            cookieNameList.map((list, index)=> (
                                <PopNotification key={index}
                                                 popupNumber={index}
                                                 popupContent={list}
                                                 showLength={showLength}
                                                 setShowLength={setShowLength}/>
                            ))
                        }
                    </div>
                    :<></>
            }
        </>
    )
}

function EventPopupDialog(){
    const [show, setShow] = useState<boolean>(setSpecialEventPopState)

    function setSpecialEventPopState(){
        const eventCookie = getCookie('sp_event_3')
        if(!eventCookie){
            const dayAgo = new Date(new Date().getTime() + (60000 * 60 * 2))
            setCookie(`sp_event_3`, "1", {
                path: '/', expires: dayAgo
            })
            return true;
        }else{
            return false;
        }
    }
    function handleCookieDeleteClose(){
        setShow(false)
        window.document.body.style.overflow = 'visible'

        const dayAgo = new Date(new Date().getTime() + (60000 * 60 * 2))
        setCookie(`sp_event_3`, "0", {
            path: '/', expires: dayAgo
        })
    }

    useEffect(()=> {
        const eventCookie = getCookie('sp_event_3')
        if(eventCookie == `1`){
            setShow(true)
            window.document.body.style.overflow = 'hidden'
        }else{
            setShow(false)
            window.document.body.style.overflow = 'visible'
        }

    }, [])

    return (
        show
            ? <div className={'pop-event-dialog'}>
                <div className={'pop-event-body'}>
                    <div className={'close-event'} onClick={e=> {
                        setShow(false)
                        window.document.body.style.overflow = 'visible'
                    }}>
                        <FontAwesomeIcon icon={faXmark} size={`2x`}/>
                    </div>
                    <div className="btn-area">
                        <button onClick={handleCookieDeleteClose}>2시간 안보이기</button>
                    </div>
                </div>
            </div>
            : <></>

    )
}
